module.exports = __webpack_public_path__ + "static/chart-lean-7041f8d5e7a1573c2d81a7ffc6546d6b.svg";